import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type WorkflowResponseResourceV3 = OpalApiComponent<'V3', 'workflow_response'>

export const workflowResponseResourceFactory: Factory<WorkflowResponseResourceV3> =
  Factory.define<WorkflowResponseResourceV3>(() => {
    const now = new Date().toISOString()
    return {
      id: uuidV4(),
      type: 'workflow_response',
      attributes: {
        created_at: now,
        updated_at: now,
        details: { complete: true },
      },
      relationships: {
        assignment: { data: { id: uuidV4(), type: 'workflow_assignment' } },
        created_by_user: { data: { id: uuidV4(), type: 'user' } },
      },
    } satisfies WorkflowResponseResourceV3
  })
